module.exports = __webpack_public_path__ + "static/img/mark.a02dd10e.svg";